
namespace GeniuzPOS.QRreport {

    @Serenity.Decorators.registerClass()
    export class QDayDataDialog extends Serenity.EntityDialog<QDayDataRow, any> {
        protected getFormKey() { return QDayDataForm.formKey; }
        protected getIdProperty() { return QDayDataRow.idProperty; }
        protected getLocalTextPrefix() { return QDayDataRow.localTextPrefix; }
        protected getNameProperty() { return QDayDataRow.nameProperty; }
        protected getService() { return QDayDataService.baseUrl; }
        protected getDeletePermission() { return QDayDataRow.deletePermission; }
        protected getInsertPermission() { return QDayDataRow.insertPermission; }
        protected getUpdatePermission() { return QDayDataRow.updatePermission; }

        protected form = new QDayDataForm(this.idPrefix);

    }
}